import React from 'react';
import * as ReactDOMServer from 'react-dom/server';

/**
 * Renderiza um componente React Email para HTML
 * @param EmailComponent - O componente React Email
 * @param props - As propriedades para o componente
 * @returns HTML renderizado como string
 */
export const renderEmailToHtml = <T,>(
  EmailComponent: React.ComponentType<T>,
  props: T
): string => {
  // Use createElement para criar o elemento React e depois renderizar para HTML estático
  const element = React.createElement(EmailComponent, props);
  return ReactDOMServer.renderToStaticMarkup(element);
};

/**
 * Substitui as variáveis em um template HTML usando o formato {{variavel}}
 * @param html - O conteúdo HTML do template
 * @param data - Objeto com os valores das variáveis para substituir
 * @returns HTML com as variáveis substituídas
 */
export const replaceTemplateVariables = (
  html: string, 
  data: Record<string, string>
): string => {
  let processedHtml = html;
  
  Object.keys(data).forEach(key => {
    const regex = new RegExp(`{{${key}}}`, 'g');
    processedHtml = processedHtml.replace(regex, data[key]);
  });
  
  return processedHtml;
}; 